import { render, staticRenderFns } from "./NicklistUser.vue?vue&type=template&id=0543df6d&functional=true&"
import script from "./NicklistUser.vue?vue&type=script&lang=js&"
export * from "./NicklistUser.vue?vue&type=script&lang=js&"
import style0 from "./NicklistUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports